"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var types = _interopRequireWildcard(require("./types"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    conditionsPageable: {
      content: []
    },
    isFetchingConditions: false,
    isAddingCondition: false,
    isEditingCondition: false,
    isDeletingCondition: false,
    conditionEventsPageable: {
      content: []
    },
    isFetchingConditionEvents: false
  };
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case types.CONDITIONS_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        conditionsPageable: {
          content: []
        },
        isFetchingConditions: true
      });

    case types.CONDITIONS_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchingConditions: false,
        conditionsPageable: action.conditions
      });

    case types.CONDITIONS_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchingConditions: false
      });

    case types.CONDITION_EVENTS_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        conditionEventsPageable: {
          content: []
        },
        isFetchingConditionEvents: true
      });

    case types.CONDITION_EVENTS_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchingConditionEvents: false,
        conditionEventsPageable: action.conditionEvents
      });

    case types.CONDITION_EVENTS_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchingConditionEvents: false
      });

    case types.CONDITION_ADD_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        isAddingCondition: true
      });

    case types.CONDITION_ADD_SUCCESS:
      state.conditionsPageable.content.push(action.newCondition);
      return _objectSpread(_objectSpread({}, state), {}, {
        isAddingCondition: false,
        conditionsPageable: state.conditionsPageable
      });

    case types.CONDITION_ADD_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        isAddingCondition: false
      });

    case types.CONDITION_EDIT_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        isEditingCondition: true
      });

    case types.CONDITION_EDIT_SUCCESS:
      state.conditionsPageable.content.map(function (condition, index) {
        if (condition.id === action.updatedCondition.id) {
          state.conditionsPageable.content[index] = action.updatedCondition; // eslint-disable-line
        }

        return condition;
      });
      return _objectSpread(_objectSpread({}, state), {}, {
        isEditingCondition: false,
        conditionsPageable: state.conditionsPageable
      });

    case types.CONDITION_EDIT_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        isEditingCondition: false
      });

    case types.CONDITION_DELETE_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        isDeletingCondition: true
      });

    case types.CONDITION_DELETE_SUCCESS:
      state.conditionsPageable.content = // eslint-disable-line
      state.conditionsPageable.content.filter(function (condition) {
        return condition.id !== action.conditionId;
      });
      return _objectSpread(_objectSpread({}, state), {}, {
        isDeletingCondition: false,
        conditionsPageable: state.conditionsPageable
      });

    case types.CONDITION_DELETE_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        isDeletingCondition: false
      });

    default:
      return state;
  }
};

exports["default"] = _default;